import { environmentConfig } from "@configs/environmentConfig";

const SALT = environmentConfig.SALT;

export const encodeId = (userId: string, email: string): string => {
  const raw = JSON.stringify({ userId, email, salt: SALT });
  return btoa(raw); // base64 encode
};

export const decodeId = (
  encoded: string
): { userId: string; email: string } | null => {
  try {
    const decoded = JSON.parse(atob(encoded));
    if (decoded.salt !== SALT) return null; // Invalid salt
    return { userId: decoded.userId, email: decoded.email };
  } catch (err) {
    console.error("Invalid encoded user ID/email:", err);
    return null;
  }
};
